import { Anchor, FlexRow, Text, theme } from '@veeqo/ui';
import { useTranslation } from 'context/TranslationContext';
import { ContentStyle, copy } from '../content';

export const Footer = ({ contentStyle }: { contentStyle: ContentStyle }) => {
  const { t } = useTranslation();
  return (
    <FlexRow
      justifyContent="space-between"
      style={{
        padding: theme.sizes[12],
        width: `calc(100% - ${parseInt(theme.sizes[12], 10) * 2}rem)`,
      }}
    >
      <FlexRow justifyContent="flex-start" gap="md">
        <Anchor
          variant="unstyled"
          href={copy[contentStyle].termsUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Text variant="body" style={{ color: 'white', opacity: 0.8 }}>
            {t(copy[contentStyle].termsTextId)}
          </Text>
        </Anchor>
        <Anchor
          variant="unstyled"
          href={copy[contentStyle].privacyUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Text variant="body" style={{ color: 'white', opacity: 0.8 }}>
            {t(copy[contentStyle].privacyTextId)}
          </Text>
        </Anchor>
        <Anchor
          variant="unstyled"
          href={copy[contentStyle].securityUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Text variant="body" style={{ color: 'white', opacity: 0.8 }}>
            {t(copy[contentStyle].securityTextId)}
          </Text>
        </Anchor>
      </FlexRow>
      <Text variant="body" style={{ color: 'white', opacity: 0.8 }}>
        {copy[contentStyle].copyrightText(new Date().getFullYear())}
      </Text>
    </FlexRow>
  );
};
